export default "__VITE_ASSET__DOfQylvs__"